export default __webpack_public_path__ + "static/article-renovation-ideas-955f9225ee9c871d764c7505d2a840bf.jpg";